import $ from 'jquery';
import { getLogger } from 'cadenza/utils/logging';

const logger = getLogger('ui/menu/legacy-menu');

let closeMenu;
let openMenu;
let currentMenu;

let closeTimeout;
let openTimeout;

const allCloseEvents = 'pointerdown pointermove wheel click';
const defaultCloseEvents = 'pointerdown wheel click';

$(document).on(allCloseEvents, event => {
  if (currentMenu && !event.target.closest('d-flyout') && currentMenu.closeMenuEvents.includes(event.type) && currentMenu.closeMenuCheck(event)) {
    if (event.type === 'mousemove') {
      scheduleClose(currentMenu);
    } else {
      closeNow(currentMenu);
    }
  }
});

$(window).on('resize', () => {
  if (currentMenu) {
    closeNow(currentMenu);
  }
});

function scheduleOpen (menu, event) {
  cancelClose(menu);
  if (menu.visible) {
    if (openMenu) {
      cancelOpen(openMenu);
    }
  } else if (openMenu !== menu) {
    logger.debug('scheduleOpen', menu, menu.openDelay);
    openMenu = menu;
    openTimeout = setTimeout(() => {
      if (currentMenu) {
        currentMenu.close();
      }
      menu.open(event);
      currentMenu = menu;
      openMenu = null;
    }, menu.openDelay);
  }
}

function scheduleClose (menu) {
  cancelOpen(menu);
  if (!menu.visible) {
    if (closeMenu) {
      cancelClose(closeMenu);
    }
  } else if (closeMenu !== menu) {
    logger.debug('scheduleClose', menu, menu.closeDelay);
    closeMenu = menu;
    closeTimeout = setTimeout(() => {
      closeNow(menu);
    }, menu.closeDelay);
  }
}

function closeNow (menu) {
  cancelOpen(menu);
  cancelClose(menu);
  menu.close();
  if (menu === currentMenu) {
    currentMenu = null;
  }
  closeMenu = null;
}

function cancelClose (menu) {
  if (closeMenu === menu) {
    logger.debug('cancelClose', menu);
    clearTimeout(closeTimeout);
    closeMenu = null;
  }
}

function cancelOpen (menu) {
  if (openMenu === menu) {
    logger.debug('cancelOpen', menu);
    clearTimeout(openTimeout);
    openMenu = null;
  }
}

export class LegacyMenu {

  constructor ({
    openDelay = 0,
    closeDelay = 100,
    open,
    closeMenuEvents = defaultCloseEvents,
    closeMenuCheck = () => true,
    close
  }) {
    Object.assign(this, { openDelay, closeDelay, closeMenuEvents, closeMenuCheck });

    this.open = (event) => {
      this._menu = open.call(this, event);
      $(this._menu).on(closeMenuEvents, (event) => cancelClose(this));
    };
    this.close = () => {
      close.call(this);
      this._menu = null;
    };
  }

  get visible () {
    return this._menu != null;
  }

  scheduleOpen (event) {
    if (this.closeMenuEvents.includes(event.type)) {
      event.stopPropagation();
    }
    scheduleOpen(this, event);
  }

  scheduleClose () {
    scheduleClose(this);
  }

  closeNow () {
    closeNow(this);
  }

}
